import { useSelector } from '@xstate/react';
import { FC, useState } from 'react';

import { SimpleTooltip } from '@eluve/components';
import { Button, Icon } from '@eluve/components';

import { useSegmentAudioContext } from './SegmentAudioContextStore';

export interface UtteranceActionsProps {
  utteranceIdx: number;
  utteranceId: string;
  isReadonly: boolean;
  hasHumanUpdatedText: boolean;
  mergeUtterance: (utteranceId: string) => Promise<void>;
  resetUtterance: (utteranceId: string) => Promise<void>;
}

export const UtteranceActions: FC<UtteranceActionsProps> = ({
  utteranceIdx,
  utteranceId,
  isReadonly,
  hasHumanUpdatedText,
  mergeUtterance,
  resetUtterance,
}) => {
  const { store } = useSegmentAudioContext();

  const isFocused = useSelector(
    store,
    (state) => state.context.focusedUtteranceId === utteranceId,
  );
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => {
          setIsLoading(true);
          mergeUtterance(utteranceId).finally(() => setIsLoading(false));
        }}
        aria-label="Merge Utterance"
        disabled={utteranceIdx === 0 || isReadonly || isLoading}
      >
        <Icon name="Merge" size="auto" />
      </Button>
      {isFocused ? (
        <SimpleTooltip label="Click 'Close' or exit edit mode to reset this utterance">
          <Button
            variant="outline"
            size="sm"
            aria-label="Reset Utterance"
            disabled={true}
          >
            <Icon name="RefreshCw" size="auto" />
          </Button>
        </SimpleTooltip>
      ) : (
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            setIsLoading(true);
            resetUtterance(utteranceId).finally(() => setIsLoading(false));
          }}
          aria-label="Reset Utterance"
          disabled={isReadonly || !hasHumanUpdatedText || isLoading}
        >
          <Icon name="RefreshCw" size="auto" />
        </Button>
      )}
    </>
  );
};
